// Import model
import { DataviewLeadNoteResponse } from '../models/DataviewLeadNoteResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterLeadNoteRequest } from '../models/FilterLeadNoteRequest';
import { LeadNote } from '../models/LeadNote';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterLeadNoteRequestSerializer } from './FilterLeadNoteRequestSerializer';
import { LeadNoteSerializer } from './LeadNoteSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewLeadNoteResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewLeadNoteResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewLeadNoteResponse instance
   */
  static deserialize(json: string): DataviewLeadNoteResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewLeadNoteResponse instance
   */
  static fromObject(obj: any): DataviewLeadNoteResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewLeadNoteResponse');
    }


    const instance: DataviewLeadNoteResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        LeadNoteSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterLeadNoteRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewLeadNoteResponse instances
   */
  static deserializeArray(json: string): DataviewLeadNoteResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewLeadNoteResponse instance to a JSON string
   */
  static serialize(instance: DataviewLeadNoteResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewLeadNoteResponse instance to a plain object
   */
  static toObject(instance: DataviewLeadNoteResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        LeadNoteSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterLeadNoteRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewLeadNoteResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewLeadNoteResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
